<template>
  <div ref="container" class="flex gap-4 px-[2vw] pt-8 overflow-x-auto snap-x snap-mandatory snap-center scrollbar-hide"
    @scroll="handleScroll">
    <div v-for="(promotion, i) in promotions" :key="promotion.image_link" :style="{
      backgroundImage: `url(${promotion.image_link})`,
      transition: 'background-position 0.25s ease-in-out'
    }"
      class="relative min-w-[96vw] h-[600px] max-h-[65vh] snap-center bg-cover bg-center bg-no-repeat rounded-xl overflow-hidden flex flex-col ">
      <div class="mt-auto w-2/3 md:max-w-lg ps-5 pb-5 md:ps-10 md:pb-10">
        <span class="block text-white">{{ promotion.subtitle }}</span>
        <span class="block text-white text-xl md:text-3xl">{{ promotion.title }}</span>
        <div class="mt-5">
          <a class="py-2 px-3 inline-flex items-center gap-x-2 text-sm font-medium rounded-xl bg-white border border-transparent text-black hover:bg-gray-100 focus:outline-hidden focus:bg-gray-100 disabled:opacity-50 disabled:pointer-events-none"
            href="#">
            Read Case Studies
          </a>
        </div>
      </div>
      <!-- Overlay -->
      <div class="absolute inset-0 transition-opacity transition-filter duration-1000 ease"
        :class="currentIndex === i ? 'opacity-0 grayscale-0' : 'opacity-100 grayscale'"></div>
    </div>
  </div>
</template>
  
<script>
export default {
  props: {
    promotions: {
      type: Array,
      required: true
    },
    autoscroll: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      autoScrollInterval: null,
      currentIndex: 0,
      autoScrollIntervalDelay: 5000,
    }
  },
  mounted() {
    const container = this.$refs.container
    if (!container) return

    if (this.autoscroll) {
      this.autoScrollInterval = setInterval(() => {
        this.currentIndex = (this.currentIndex + 1) % this.promotions.length
        const nextElement = container.children[this.currentIndex]
        if (nextElement) {
          container.scrollTo({
            left: nextElement.offsetLeft,
            behavior: "smooth"
          })
        }
      }, this.autoScrollIntervalDelay)
    }
  },
  beforeDestroy() {
    clearInterval(this.autoScrollInterval)
  },
  methods: {
    handleScroll() {
      const container = this.$refs.container
      if (!container) return

      const scrollLeft = container.scrollLeft
      const containerWidth = container.clientWidth
      this.currentIndex = Math.round(scrollLeft / containerWidth) % container.children.length
    }
  }
}
</script>
  
<style>
/* hide scrollbar */
.scrollbar-hide::-webkit-scrollbar {
  display: none;
}

.scrollbar-hide {
  -ms-overflow-style: none;
  scrollbar-width: none;
}
</style>
  